module.exports = "https://coursera_assets.s3.amazonaws.com/images/85374a7ca3075e68f08d02ea6e616de2.png";